import React from 'react';
import PropTypes from 'prop-types';
import AddAudio from '../AddAudio/AddAudio';
import { change } from 'redux-form';
import { publicKey } from 'config';

const WordAgsAddAudio = ({ 
  locale,
  activeGroupId,
  current,
  onChangeAudio,
  associatedText
}) => {
  // The cached helpFilesPath can be empty or belong to a previously selected
  // group. Derive the destination from the current Help dialog on every render.
  const groupId = String(activeGroupId || '').trim();
  const language = String(locale || '').trim();
  const path = groupId && language
    ? `${publicKey}/WordAGs/${groupId}/HelpAudio/${language}`
    : '';

  return (
    <AddAudio
      disabledButton={!associatedText || !path}
      saveAfterChange
      path={path}
      removeOldOnChange
      current={current}
      onChangeHandler={filename => {
        //change('WordAgsForm', `multilangWordsHelp.[${activeGroupId}].helpAudio`, filename ?? '');
        change('WordAgsForm', `multilangWordsHelp.[${activeGroupId}].${locale}.helpAudio`, filename ?? '');
        onChangeAudio(filename);
      }}
      versionType={`immersion_${locale}`}
      allowedLocales={[locale]}
      associatedText={associatedText}
      isWordAgs={true}
      useFileBucket={false}
    />
  );
};

WordAgsAddAudio.propTypes = {
  locale: PropTypes.string.isRequired,
  activeGroupId: PropTypes.string,
  helpFilesPath: PropTypes.string.isRequired,
  current: PropTypes.string,
  onChangeAudio: PropTypes.func.isRequired,
  associatedText: PropTypes.string,
};

export default WordAgsAddAudio;
